'use strict';

const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    urlRoot: '/program/publish'
});
